export default {
	styleOverrides: {
		slideTransition: {},
	},
};
